import { httpRequest } from "../../../utils/HttpRequest";
import { IMaterielTypeParams, IMaterielTypeDetail, IMaterielTypeInsert,IMaterielTypeUpdate, IMaterielTypeDisable, IMaterielTypeRemove, IIMaterielTypeSearch } from "./materielTypeTypes"
import { IPage } from "../../../types/FmsTypes";

class MaterielTypeService {
    async page(params: IIMaterielTypeSearch) {
        const apiUrl = "/md/material/type/page"
        return await httpRequest.post<IPage<IMaterielTypeDetail>>(apiUrl, params)
    }
    async insert(params: IMaterielTypeInsert) {
        const apiUrl = "/md/material/type/insert"
        return await httpRequest.post<boolean>(apiUrl, params)
    } 
    async update(params: IMaterielTypeUpdate) {
        const apiUrl = "/md/material/type/update"
        return await httpRequest.post<boolean>(apiUrl, params)
    } 
    async remove(params: IMaterielTypeRemove) {
        const apiUrl = "/md/material/type/remove"
        return await httpRequest.post<boolean>(apiUrl, params)
    }
    async disable(params: IMaterielTypeRemove) {
        const apiUrl = "/md/material/type/disable"
        return await httpRequest.post<boolean>(apiUrl, params)
    }
}
const materielTypeService = new MaterielTypeService()
export {
    materielTypeService
}